import { ArrowUpRight } from "lucide-react";

const TONES = {
  blush: "bg-blush text-ink",
  ink: "bg-ink text-cream",
  gold: "bg-champagne text-ink",
  white: "bg-white text-ink border border-ink/10",
  petal: "bg-petal text-ink",
};

export function Badge({ children, tone = "blush", testid }) {
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[9px] font-bold uppercase tracking-[0.18em] ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}

export function ArrowCircle({ dark = true }) {
  return (
    <span
      className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:rotate-45 ${
        dark ? "bg-ink text-cream" : "bg-champagne text-ink"
      }`}
    >
      <ArrowUpRight size={15} />
    </span>
  );
}
